import React from "react";

const IconCheckmark = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 66 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M41.7 69.5262H14.7C6.6 69.5262 0 62.1262 0 53.1262V22.8262C0 13.7262 6.6 6.32617 14.7 6.32617H41.8C43 6.32617 44 7.42617 44 8.72617C44 10.0262 43 11.1262 41.8 11.1262H14.7C9 11.1262 4.4 16.3262 4.4 22.7262V53.0262C4.4 59.4262 9 64.6262 14.7 64.6262H41.8C47.5 64.6262 52.1 59.4262 52.1 53.0262V41.3262C52.1 40.0262 53.1 38.9262 54.3 38.9262C55.5 38.9262 56.5 40.0262 56.5 41.3262V53.0262C56.5 62.1262 49.9 69.4262 41.8 69.4262L41.7 69.5262Z" />
      <path d="M29.9992 50.426C27.1992 50.426 24.3992 49.126 22.3992 46.626L12.8992 35.226C11.0992 33.026 11.1992 29.726 13.0992 27.626C14.9992 25.626 18.0992 25.726 19.7992 27.926L29.3992 39.526C29.5992 39.726 29.8992 39.826 30.0992 39.726L56.9992 2.026C58.5992 -0.274005 61.5992 -0.674005 63.6992 1.126C65.7992 2.926 66.0992 6.326 64.4992 8.626L37.1992 47.226L36.8992 47.526C34.9992 49.426 32.5992 50.426 30.0992 50.426H29.9992Z" />
    </svg>
  );
};

export default IconCheckmark;
